export default __webpack_public_path__ + "static/media/UCSC-Logo.ed62a175.png";